var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{},[(_vm.logged)?_c('navigation',{attrs:{"user":_vm.user}},[_vm._t("navigation")],2):_vm._e(),_c('toast'),_c('section',{staticClass:"px-2 mt-16"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }